import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import Checkout from './pages/Checkout';
import Product from './pages/Product';
import Inventory from './pages/Inventory';
import ProductList from './pages/productList';
import Home from './pages/Home';
import { useCart } from './context/CartContext';
import { useAuth } from './context/AuthContext';

const getInitials = (user) => {
  if (!user) {
    return '';
  }
  const { firstName, lastName, email } = user;
  const letters = [
    firstName ? firstName.trim()[0] : '',
    lastName ? lastName.trim()[0] : '',
  ]
    .filter(Boolean)
    .join('');

  if (letters) {
    return letters.toUpperCase();
  }

  if (email) {
    return email
      .replace(/[^a-zA-Z]/g, '')
      .slice(0, 2)
      .toUpperCase();
  }
  return '?';
};

const NotFound = () => (
  <main className="not-found">
    <h1>Page not found</h1>
    <p>The page you are looking for does not exist.</p>
    <Link to="/">Return home</Link>
  </main>
);

function App() {
  const { count } = useCart();
  const { user } = useAuth();
  const initials = getInitials(user);

  return (
    <Router>
      <nav className="main-nav">
        <div className="nav-left" />
        <div className="nav-center">
          <Link to="/" className="site-name">doorimports.com</Link>
        </div>
        <div className="nav-right">
          <Link to="/productList">Products</Link>
          {user ? (
            <div
              className="user-avatar"
              aria-label={`Signed in as ${user.email}`}
              title={user.email}
            >
              {initials}
            </div>
          ) : (
            <>
              <Link to="/signin">Sign In</Link>
              <Link to="/signup">Sign Up</Link>
            </>
          )}
          <Link to="/checkout">Cart ({count})</Link>
        </div>
      </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/product" element={<Product />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/productList" element={<ProductList />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
